import {
  FaMapMarkerAlt,
  FaClock,
  FaUsers,
  FaLaptop,
  FaArrowLeft,
} from "react-icons/fa";


const locations = [
  /*
  أضف الأماكن الحقيقية هنا:
*/
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر الضوي",
    subtitle: "فرع الرضوان",
    location: "شارع الرضوان , الهانوفيل , الاسكندرية",
    students: "أولى و ثانية و ثالثة ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر الفاروق",
    subtitle: "فرع الورديان",
    location: "الورديان , الاسكندرية",
    students: "أولى و ثانية ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر الضوي",
    subtitle: "فرع زمزم",
    location: "شارع زمزم , الهانوفيل , الاسكندرية",
    students: "أولى ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر عبد الغفار",
    subtitle: "فرع الورديان",
    location: "الورديان , الاسكندرية",
    students: "أولى و ثانية ثانوي",
  },

  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر القبطان",
    subtitle: "فرع عبد القادر",
    location: "عبد القادر , الاسكندرية",
    students: "أولى و ثانية و ثالثة ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر عبد الغفار",
    subtitle: "فرع ويست",
    location: "ابو يوسف , الاسكندرية",
    students: "أولى ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر عبد المقصود",
    subtitle: "فرع الدخيلة",
    location: "الدخيلة , الاسكندرية",
    students: "أولى و ثانية ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر طيبة",
    subtitle: "فرع ابو يوسف",
    location: "ابو يوسف , الاسكندرية",
    students: "أولى  و ثانية ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر زويل",
    subtitle: "فرع الناصرية",
    location: "الناصرية , الاسكندرية",
    students: "أولى ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر سعيد",
    subtitle: "فرع الورديان",
    location: "الورديان , الاسكندرية",
    students: "أولى ثانوي",
  },
  {
    type: "center",
    icon: <FaMapMarkerAlt />,
    title: "سنتر الضوي",
    subtitle: "فرع الالسن",
    location: "ابو يوسف , الاسكندرية",
    students: "أولى ثانوي",
  },
];

const scrollToContact = () => {
  document.getElementById("contact")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};


function TeachingLocations() {
  return (
    <section className="locations_section">
      {/* HEADER */}

      <div className="locations_header">
        <span className="section_badge">أماكن الدراسة</span>

        <h2>
          اتعلم مع مستر أحمد
          <span> بالطريقة اللي تناسبك</span>
        </h2>

        <p>
          سواء بتحب تذاكر أونلاين من البيت أو تفضل الحضور، اختار الطريقة والمكان
          المناسبين ليك.
        </p>
      </div>

      {/* LOCATIONS */}

      <div className="locations_grid">
        {locations.map((item, index) => (
          <div className={`location_card ${item.type}`} key={index}>
            {/* TOP */}

            <div className="location_top">
              <div className="location_icon">{item.icon}</div>
            </div>

            {/* TITLE */}

            <h3>{item.title}</h3>

            <span className="location_subtitle">{item.subtitle}</span>

            {/* LOCATION */}

            <div className="location_info">
              <div>
                <FaMapMarkerAlt />

                <span>{item.location}</span>
              </div>

              <div>
                <FaUsers />

                <span>{item.students}</span>
              </div>
            </div>

          </div>
        ))}
      </div>

      {/* BOTTOM CTA */}

      <div className="locations_cta">
        <div>
          <strong>مش عارف تختار المكان المناسب؟</strong>

          <span>تواصل معانا وهساعدك تختار المجموعة المناسبة ليك.</span>
        </div>

        <button onClick={scrollToContact} className="locations_cta_btn">
          تواصل معنا
        </button>
      </div>
    </section>
  );
}


export default TeachingLocations;
